/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState } from 'react';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import {
  SettingsComp,
  ISettingsCompProps,
  UsersList,
  IUsersListProps,
} from './components';
import toast from 'react-hot-toast';

const SwalWithBootstrapButtons = withReactContent(
  Swal.mixin({
    customClass: {
      confirmButton: 'btn btn-primary me-3',
      cancelButton: 'btn btn-secondary',
    },
    buttonsStyling: false,
  })
);

export type IUsersListTableProps = ISettingsCompProps &
  IUsersListProps & {
    ultUsers: any[];
    deleteItems?(ids: any): void;
    suspendItems?(ids: any): void;
    inviteUsers?(ids: any): void;
    userResetPassword?(ids: any): void;
    onTogglePress?(key: string, email: string): void;
  };

export const UsersListTable = ({
  ultUsers,
  deleteItems,
  suspendItems,
  inviteUsers,
  userResetPassword,
  onTogglePress,
  onViewClick,
  onEditClick,
  ...rest
}: IUsersListTableProps) => {
  const [users, setUsers] = useState(
    ultUsers.map((u) => ({ ...u, isSelected: false, show: true }))
  );
  const selectedUsersIds = users.filter((u) => u.isSelected).map((u) => u.id);
  const totalUsers = users.length;
  const allSelected = selectedUsersIds.length === totalUsers;

  const selectUser = (id) => {
    console.log('select user =>', id);
    const newUsers = users.map((u) =>
      u.id === id ? { ...u, isSelected: !u.isSelected } : u
    );
    setUsers(newUsers);
  };

  const selectAllUsers = () => {
    const newUsers =
      selectedUsersIds.length === totalUsers
        ? users.map((u) => ({ ...u, isSelected: false }))
        : users.map((u) => ({ ...u, isSelected: true }));
    setUsers(newUsers);
  };
  const deleteUsers = async (ids) => {
    const usersToBeDeleted = ids;
    console.log('usersToBeDeleted =>', usersToBeDeleted);
    const usersNr = usersToBeDeleted.length;
    const textMessage = 'Are you sure do you want to delete this user?';
    // usersNr === 1
    //   ? "Are you sure do you want to delete this user?"
    //   : `Are you sure do you want to delete these ${usersNr} users?`;

    //@ts-ignore
    const result = await SwalWithBootstrapButtons.fire({
      icon: 'error',
      title: 'Confirm deletion',
      text: textMessage,
      allowOutsideClick: false,
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel',
    });

    if (result.isConfirmed) {
      deleteItems && deleteItems(usersToBeDeleted);
      // toast.error("Coming soon !");
    }
  };

  const suspendUsers = async () => {
    const usersToBeSuspended = selectedUsersIds;
    const usersNr = usersToBeSuspended.length;
    const textMessage =
      usersNr === 1
        ? 'Are you sure do you want to suspend this user?'
        : `Are you sure do you want to suspend these ${usersNr} users?`;

    //@ts-ignore
    const result = await SwalWithBootstrapButtons.fire({
      icon: 'warning',
      title: 'Confirm Suspend',
      text: textMessage,
      allowOutsideClick: false,
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel',
    });

    if (result.isConfirmed) {
      suspendItems && suspendItems(usersToBeSuspended);
      // toast.error("Coming soon !");
    }
  };

  const onToggleClick = async (key: string, email: string) => {
    if (key !== 'view' && key !== 'edit') {
      const textMessage = `Are you sure do you want to ${key} this user`;
      //@ts-ignore
      const result = await SwalWithBootstrapButtons.fire({
        icon: 'warning',
        title: `Confirm ${key}`,
        text: textMessage,
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
      });

      if (result.isConfirmed) {
        onTogglePress && onTogglePress(key, email);
      }
    }
  };

  const bulkInvite = async () => {
    const usersToInvite = selectedUsersIds;
    const usersNr = usersToInvite.length;
    const textMessage =
      usersNr === 1
        ? 'Are you sure do you want to invite this user?'
        : `Are you sure do you want to invite these ${usersNr} users?`;

    //@ts-ignore
    const result = await SwalWithBootstrapButtons.fire({
      icon: 'warning',
      title: 'Confirm Invite',
      text: textMessage,
      allowOutsideClick: false,
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel',
    });

    if (result.isConfirmed) {
      inviteUsers && inviteUsers(usersToInvite);
    }
  };

  const resetPassword = async () => {
    const usersToResetPassword = selectedUsersIds;
    const usersNr = usersToResetPassword.length;
    const textMessage =
      usersNr === 1
        ? 'Are you sure do you want to Reset Password for this user?'
        : `Are you sure do you want to Reset Password for these ${usersNr} users?`;

    //@ts-ignore
    const result = await SwalWithBootstrapButtons.fire({
      icon: 'warning',
      title: 'Confirm Reset Password',
      text: textMessage,
      showCancelButton: true,
      allowOutsideClick: false,
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel',
    });

    if (result.isConfirmed) {
      userResetPassword && userResetPassword(usersToResetPassword);
    }
  };

  return (
    <>
      {/* <SettingsComp {...rest} /> */}
      <UsersList
        {...rest}
        users={users.filter((u) => u.show)}
        allSelected={allSelected}
        ultSelectUser={selectUser}
        ultDeleteUser={deleteUsers}
        ultInviteUser={bulkInvite}
        ultSuspendUser={suspendUsers}
        ultResetPassword={resetPassword}
        ultSelectAllUsers={selectAllUsers}
        onTogglePress={onToggleClick}
        onViewClick={onViewClick}
        onEditClick={onEditClick}
      />
    </>
  );
};

UsersListTable.defaultProps = {
  ultUsers: [],
};
